module.exports = __webpack_public_path__ + "img/tottenham-hotspur-logo-icon.94865f36.png";